// modules/Stageplan.js
import React from 'react';
import $                from 'jquery';
import PlanDisplay      from './elements/PlanDisplay';
import PlanLegend 		from './elements/PlanLegend';
import BackButton       from '../common/BackButton';
import LotButton        from './elements/LotButton';
import StageButton        from './elements/StageButton';
import DownloadButton   from '../common/DownloadButton';
// import SiteDownloads    from '../common/SiteDownloads';
import SiteDownloadButton    from '../common/SiteDownloadButton';
import PageLoading      from '../PageLoading';

import '../App.css';

import Messenger        from '../common/Messenger';
let messenger 			= new Messenger();

var sources = require('../config.json');

class Stageplan extends React.Component {
	constructor(props) {
		super(props);

		var d = new Date();
		this.stageplan_url = sources.stageplan + '/' + this.props.params.stage + "?ts=" + d.getTime();

		this.state = {
			data: {
				plan: {},
				downloads: [],
				elements: [],
				stages: [],
			},
			available: []
		};

		this.receivedStageplanData  = this.receivedStageplanData.bind(this);
		this.eachLotButton          = this.eachLotButton.bind(this);
		this.eachStageButton        = this.eachStageButton.bind(this);
		this.planDisplay      		= this.planDisplay.bind(this);
	}

	componentWillMount() {
		window.scrollTo(0, 0);
	}

	changeButtonState(slug) {
		var newstageplan_url = sources.stageplan + '/' + slug;

		// blank things to get page loading spinner
		let newState = Object.assign(this.state, {
			data: {
				plan: {},
				downloads: [],
				elements: [],
				stages: [],
			},
			available: []
		});
		this.setState(newState);

		$.ajax({url:newstageplan_url,dataType:'json'}).done(this.receivedStageplanData);

		window.scrollTo(0, 0);
	}


	componentDidMount() {
		$.ajax({url:this.stageplan_url,dataType:'json'}).done(this.receivedStageplanData);
	}

	receivedStageplanData(data, status, xhr) {
		var available = this.filterLots(data.elements,sources.activestatus);

		if(typeof data.plan === 'undefined') data.plan = [];
		if(typeof data.downloads === 'undefined') data.downloads = [];
		if(typeof data.elements === 'undefined') data.elements = [];

		let newState = Object.assign(this.state, {
			data: data,
			available: available
		});

		this.setState(newState);
	}

	filterLots(elements,type) {
		var result = [];
		result = elements.reduce(function (accum, current) {
			if (type.includes(current.status))
				accum.push(current);
			return accum;
		}, []);

		return result;
	}

	eachLotButton(element, index) {
		if (element.length !== 0) {
			return (
				<div key={index}>
					<LotButton key={element.id} messenger={messenger} id={element.id} index={index} buttonlink={element.link} buttonclass={element.class} >{element.description}</LotButton>
				</div>
			)
		} else {
			return null;
		}
	}

	eachStageButton(element, index) {
		if (element.length !== 0) {
			return (
				<div key={index}>
					<StageButton key={element.id} id={element.id} index={index} buttonlink={element.link} buttonclass={"stage-link-button"} slug={element.slug} linkclick={this.changeButtonState.bind(this)} >{element.name}</StageButton>
				</div>
			)

		} else {
			return null;
		}
	}

	eachLandscapeLotButton(element) {
		if (element.length !== 0) {
			return (
				<div key={element.id} className="LnButtonWrapper">
					<LotButton key={element.id}	id={element.id} messenger={messenger} buttonlink={element.link} buttonclass={element.class}>{element.description}</LotButton>
				</div>
			)
		} else {
			return null;
		}
	}

	planDisplay() {
		if (typeof this.state.data.plan.plan_id !== "undefined") {
			return (
				<PlanDisplay key={this.state.data.plan.plan_id} messenger={messenger} plan={this.state.data.plan} elements={this.state.data.elements} plantype="stageplan">stage plan</PlanDisplay>
			)
		} else {
			return null;
		}
	}

	lotDownloadBlock(downloads) {
		if (downloads.length !== 0) {
			return (
				<div>
					{downloads.map(this.lotDownloadButtons)}
				</div>
			)
		} else {
			return null;
		}
	}

	lotDownloadButtons(download){
		return (
			<DownloadButton bclass="stage-download-button" key={download.download_id} link={download.download_pdf}>{download.download_title}</DownloadButton>
		)
	}

	render() {
		if (typeof this.state.data.plan.plan_id !== "undefined") {
			let re = new RegExp(' ','g');
			return (
				<div className="stage-container" id={this.state.data.plan.plan_name.replace(re,"")}>
					<div>
						<div className="LnButtonContainer"><BackButton link={sources.landforsalepath} bclass="stage-back-button">Return to Land for sale</BackButton></div>
						<div className="LnButtonContainer"><PlanLegend/></div>
						<div className="clear-div"/>
					</div>
					<div id="PrH1ListContainer">
						<div className="stage-title-container">
							<h1 className="stage-title">{this.state.data.plan.plan_name}</h1>
						</div>
					</div>
					<div id="PrImageAreaContainer">
						{this.planDisplay()}
					</div>
					<div id="PrDetailsListContainer">
						<div className="LotsContainer" id="LotsContainer">
							{this.state.available.map(this.eachLotButton)}
						</div>
					</div>
					<div className="clear-div"/>
					<div id="PrStagesContainer">
						{this.state.data.stages.map(this.eachStageButton)}
					</div>
					<div id="PrDownloadsContainer">
						<SiteDownloadButton key="1" buttonlink={this.state.data.downloads[0].download_pdf}>download release plan</SiteDownloadButton>
						<SiteDownloadButton key="2" buttonlink={this.state.data.downloads[1].download_pdf}>download master plan</SiteDownloadButton>
						<SiteDownloadButton key="3" buttonlink={this.state.data.plan.local_development_plan}>{'download local<br/>development plan'}</SiteDownloadButton>
						<SiteDownloadButton key="4" buttonlink={this.state.data.plan.design_guidelines}>{'download<br/>design guidelines'}</SiteDownloadButton>
						<SiteDownloadButton key="5" buttonlink={this.state.data.plan.deposited_plan}>{'download<br/>deposited plans'}</SiteDownloadButton>
					</div>
					<div className="clear-div"/>
				</div>

			)
		} else {
			return (
				<PageLoading>Stage</PageLoading>
			)
		}
	}
}

export default Stageplan;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/Stageplan.js
 **/